/**
 * Create the store with dynamic reducers
 */

import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware, connectRouter } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';

import createReducer from './reducers';
import history from './utils/history';
import { updateProcessOnBrowserAction } from './redirection';
import { updateProcessOnBrowserActionMV } from './redirectionMV';
import { isMoversFlow } from './components/common/Helpers';

const reduxSagaMonitorOptions = {};
export const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);

// export default function configureStore(initialState = {}, history) {
let composeEnhancers = compose;

// If Redux Dev Tools and Saga Dev Tools Extensions are installed, enable them
/* istanbul ignore next */
if (typeof window === 'object') {
  if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 });

  // NOTE: Uncomment the code below to restore support for Redux Saga
  // Dev Tools once it supports redux-saga version 1.x.x
  // if (window.__SAGA_MONITOR_EXTENSION__)
  //   reduxSagaMonitorOptions = {
  //     sagaMonitor: window.__SAGA_MONITOR_EXTENSION__,
  //   };
}

// Create the store with two middlewares
// 1. sagaMiddleware: Makes redux-sagas work
// 2. routerMiddleware: Syncs the location/URL path to the state
const middlewares = [sagaMiddleware, routerMiddleware(history)];

const enhancers = [applyMiddleware(...middlewares)];

export function saveToLocalStorage(state) {
  try {
    const { appointmentSchedule, createProfile, perksAndServices, ...stateToCache } = state || {};
    const serializedState = JSON.stringify(stateToCache);
    localStorage.setItem('state', serializedState);
  } catch (err) {
    console.log('saveToLocalStorage =>', err);
  }
}

function loadFromLocalStorage() {
  try {
    if (window.location.hostname === 'localhost') {
      return undefined;
    }
    const serializedState = localStorage.getItem('state');
    if (!serializedState) return undefined;
    return JSON.parse(serializedState);
  } catch (err) {
    console.warn('Failed to load state from localStorage:', err);
    return undefined;
  }
}

window.addEventListener('popstate', () => {
  if (isMoversFlow()) {
    updateProcessOnBrowserActionMV(document.location);
  } else {
    updateProcessOnBrowserAction(document.location);
  }
});

window.addEventListener('load', () => {
  if (isMoversFlow()) {
    updateProcessOnBrowserActionMV(document.location);
  } else {
    updateProcessOnBrowserAction(document.location);
  }
});

// to update state to local storage on page unload.
window.addEventListener('pagehide', () => {
  saveToLocalStorage(store.getState());
});

const persistedState = loadFromLocalStorage();
// DO NOT MERGE THIS IN BUG-STILL IN TESTING PHASE - END

export const store = createStore(connectRouter(history)(createReducer()), persistedState, composeEnhancers(...enhancers));

// store.subscribe(() => saveToLocalStorage(store.getState()));
// Extensions
store.runSaga = sagaMiddleware.run;
store.injectedReducers = {}; // Reducer registry
store.injectedSagas = {}; // Saga registry

// Make reducers hot reloadable, see http://mxs.is/googmo
/* istanbul ignore next */
if (module.hot) {
  module.hot.accept('./reducers', () => {
    store.replaceReducer(createReducer(store.injectedReducers));
  });
}
